<template>
  <div class="animated fadeIn">
    <b-card>
      <iframe src="https://m-webmapplotter-2018.azurewebsites.net/web/barchart/barchart.html" style="width:100%;height:700px;"></iframe>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'dashboard'
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue